// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__14h8a","question":"Question_question__ffGFE","section":"Question_section__3zpn8","backButton":"Question_backButton__fyURr"};